import Image from 'next/legacy/image';
import React from 'react';

import { useExperimentStatus } from '@/flags/use-experiments';

import { ContentSlider } from './ContentSlider.component';

export interface Image {
  source: string;
  altText: string;
  id: string;
}

interface ImageSliderProps {
  images: Image[];
}

export const ImageSlider = (props: ImageSliderProps) => {
  const lightboxEnabled = useExperimentStatus('feature-lightbox');

  return (
    <div css={{ paddingBottom: '32px' }}>
      <ContentSlider
        lightboxContent={
          lightboxEnabled
            ? props.images.map((image) => (
                // NextJS's Image component is adding wrappers around the image, that are hard to work around
                // TODO: revisit with a version bump of next/image
                // eslint-disable-next-line @next/next/no-img-element
                <img
                  src={image.source}
                  key={image.id}
                  alt={image.altText}
                  width={600}
                  height={600}
                  style={{
                    width: 'auto',
                    height: 'auto',
                    objectFit: 'contain',
                    // Prevent image from being highlighted with blue overlay when prev/next buttons are clicked
                    userSelect: 'none',
                    WebkitUserSelect: 'none',
                    MozUserSelect: 'none',
                    msUserSelect: 'none',
                  }}
                />
              ))
            : undefined
        }
      >
        {props.images.map((image, index) => (
          <Image
            src={image.source}
            key={image.id}
            alt={image.altText}
            // 6x4 aspect ratio
            width={600}
            height={400}
            layout="responsive"
            objectFit="cover"
            priority={index === 0}
            loading={index === 0 ? 'eager' : 'lazy'}
          />
        ))}
      </ContentSlider>
    </div>
  );
};
